import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { textFilterAnimation } from './utilities'
import { rotate } from 'three/tsl'

gsap.registerPlugin(ScrollTrigger)

/**
 *   - data-anim-trigger: parent element for the animation
 *   - data-anim: animation type (e.g., 'heading', 'fade') 
 *   - data-anim-delay: delay before animation starts (in seconds)
 */

export const initInviewAnimations = () => {
  const animParents = document.querySelectorAll('[data-anim-trigger]')

	if (animParents.length === 0 || window.isLivePreview) return

  animParents.forEach((element) => {
		const animOffset = element.dataset.animOffset
    const animElements = element.querySelectorAll('[data-anim]')
		createTimeline(element, animElements, animOffset)
  })
}

const createTimeline = (parent, animElements, offset = '60%') => {
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: parent,
			start: `top ${offset}`,
			invalidateOnRefresh: true,
			once: true
		}
	})

	animElements.forEach((element) => {
		const type = element.dataset.anim
		const delay = parseFloat(element.dataset.animDelay)

		createAnimation(tl, element, type, delay)
	})
}

const createAnimation = (tl, element, type, delay = 0) => {

  switch (type) {
    case 'filter':
			const filterAnimation = textFilterAnimation(element)
			tl.add(() => {
				filterAnimation.play()
			}, delay)
      break
		case 'fade':
			tl.fromTo(element, {
				opacity: 0,
				y: 50
			}, {
				opacity: 1,
				y: 0,
				duration: 0.8,
				ease: 'power2.out',
			}, delay)
      break
		case 'image-scale':
			tl.fromTo(element.querySelector('picture'), {
				scale: 1.2,
				opacity: 0,
				filter: 'blur(6px)',
			}, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				duration: 1.8,
				ease: 'power2.out',
			}, delay)
			break
		case 'product-panel':
			tl.fromTo(element, {
				y: 150,
				x: 300,
				rotate: 10,
				opacity: 0,
				transformOrigin: 'top left',
			}, {
				opacity: 1,
				y: 0,
				x: 0,
				rotate: 0,
				transformOrigin: 'top left',
				duration: 1,
				ease: 'power3.inOut',
			}, delay)
			break
  }
}

export default () => {}